var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -2874)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 2874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.047 2869.861)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.414 24.242)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.1,331.483H320v-8.931A2.552,2.552,0,0,1,322.552,320H325.1Z",
    transform: "translate(-320 -320)",
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.414 35.725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.741,466.552h-5.1a.638.638,0,0,1-.638-.638V464h5.1a1.276,1.276,0,0,1,1.276,1.276v.638A.638.638,0,0,1,325.741,466.552Z",
    transform: "translate(-320 -464)",
    fill: "#ffbf9e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.379 24.242)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.931,320a6.379,6.379,0,0,0-6.379,6.379v2.552H144v3.828a1.276,1.276,0,0,0,1.276,1.276H149.1a5.1,5.1,0,0,0,5.1-5.1V320Z",
    transform: "translate(-144 -320)",
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.638,429.529h.638a1.276,1.276,0,0,0,1.276-1.276V424H64.638a.638.638,0,0,0-.638.638v4.253A.638.638,0,0,0,64.638,429.529Z",
    transform: "translate(-64 -424)",
    fill: "#ffd4be"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.552 24.242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.931,320a6.379,6.379,0,0,0-6.379,6.379v1.914H96v4.466a1.276,1.276,0,0,0,1.276,1.276H101.1a5.1,5.1,0,0,0,5.1-5.1h3.828v2.552h5.1V328.4a6.38,6.38,0,0,0,3.828-5.847V320Z",
    transform: "translate(-96 -320)",
    fill: "#0cb2c2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.586 35.725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.741,466.552h-5.1a.638.638,0,0,1-.638-.638V464h5.1a1.276,1.276,0,0,1,1.276,1.276v.638A.638.638,0,0,1,277.741,466.552Z",
    transform: "translate(-272 -464)",
    fill: "#ffd4be"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.56 21.763)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.406,
    cy: 2.406,
    r: 2.406,
    fill: "#0593ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.207 3.828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.207,64a10.207,10.207,0,1,0,0,20.414h3.828a6.379,6.379,0,0,0,6.379-6.379V74.207A10.207,10.207,0,0,0,202.207,64Z",
    transform: "translate(-192 -64)",
    fill: "#ffd4be"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.208 3.828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.4,65.42a10.205,10.205,0,0,0-5.826-1.392l-9.547,9.547a10.2,10.2,0,0,0,1.392,5.826Z",
    transform: "translate(-192.009 -64.008)",
    fill: "#1487eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.673 14.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.19,192v6.379a3.19,3.19,0,1,1,0-6.379Z",
    transform: "translate(-248 -192)",
    fill: "#ffbf9e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.7 13.889)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.984 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.094,
    cy: 1.094,
    r: 1.094,
    fill: "#463c4b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.094,
    cy: 1.094,
    r: 1.094,
    fill: "#463c4b"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.328 2.552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344,48h2.552v2.764H344Z",
    transform: "translate(-344 -48)",
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.8,16.31,376,18.552v2.764l2.816,2.065a1.417,1.417,0,0,0,.838.274h.033a1.417,1.417,0,0,0,1.417-1.417V17.417a1.417,1.417,0,0,0-2.3-1.106Z",
    transform: "translate(-376 -16)",
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.3,16.31l2.8,2.241v2.764l-2.816,2.065a1.417,1.417,0,0,1-.838.274h-.033A1.417,1.417,0,0,1,280,22.238V17.417a1.417,1.417,0,0,1,2.3-1.106Z",
    transform: "translate(-280 -16)",
    fill: "#0593ff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby3);
export default __webpack_public_path__ + "static/media/baby3.4927bda4f39710c1151619c59cb53f0e.svg";
export { ForwardRef as ReactComponent };